import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./stili.css";

const radice = document.getElementById("radice");
if (radice === null) {
  throw new Error("manca #radice in index.html");
}

createRoot(radice).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
